<template>
  <div class="student_report_shengya">
     <div class="rgtx">
       <h3><span>偏好程度</span></h3>
       <div class="grade">
         <p>强</p>
         <p>明显</p>
         <p>中等</p>
         <p>轻微</p>
         <p>中等</p>
         <p>明显</p>
         <p>强</p>
       </div>
       <div class="middle">
         <ul class="left">
           <li :class="(waixiang-neixiang)>0?'active':''">外向（E）</li>
           <li :class="(shigan-zhijue)>0?'active':''">实感（S）</li>
           <li :class="(sikao-qinggan)>0?'active':''">思考（T）</li>
           <li :class="(panduan-zhijueb)>0?'active':''">判断（J）</li>
         </ul>
         <div class="center">
           <ul class="centerLeft">
             <li>
               <div class="con_px" :style="{width:(waixiang-neixiang)/70*212+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(shigan-zhijue)/70*212+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(sikao-qinggan)/70*212+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(panduan-zhijueb)/70*212+'px'}"></div>
             </li>
           </ul>
           <ul class="centerRight">
             <li>
               <div class="con_px" :style="{width:(neixiang-waixiang)/70*212+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(zhijue-shigan)/70*212+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(qinggan-sikao)/70*212+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(zhijueb-panduan)/70*212+'px'}"></div>
             </li>
           </ul>
         </div>
         <ul class="left" style="float: right">
           <li :class="(waixiang-neixiang)<0?'active':''">（I）内向</li>
           <li :class="(shigan-zhijue)<0?'active':''">（N）直觉</li>
           <li :class="(sikao-qinggan)<0?'active':''">（F）情感）</li>
           <li :class="(panduan-zhijueb)<0?'active':''">（P）知觉</li>
         </ul>
       </div>
       <div class="conclusion">
         <p>你的人格类型为</p>
         <p class="name name1">{{name}}</p>
         <p class="name name2">{{desc&&desc.replace(/[\s|\S]*(（[\s|\S]*）)[\s|\S]*/g,'$1')}}</p>
         <p>人格特性评估结果示意图</p>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  name: "rgtx",
  props:['reportId'],
  data(){
    return {
      neixiang:'',
      panduan:'',
      qinggan:'',
      shigan:'',
      sikao:'',
      waixiang:'',
      zhijue:'',
      zhijueb:'',
      name:'',
      desc:''
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_report + this.ports.consultant.student.report.rgtx,{
        report_id:this.reportId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==0){
          const { personality }=res.data.result;
          const {neixiang,panduan,qinggan,shigan,sikao,waixiang,zhijue,zhijueb}=personality.data;
          this.neixiang=neixiang;
          this.panduan=panduan;
          this.qinggan=qinggan;
          this.shigan=shigan;
          this.sikao=sikao;
          this.waixiang=waixiang;
          this.zhijue=zhijue;
          this.zhijueb=zhijueb;
          this.name=personality.name;
          this.desc=personality.desc;
        }else{
        }
      })
    }
  },
  mounted() {
    this.getData()
  },
}
</script>
<style lang="less" scoped>
    @import '../../css/evaluationReport.less';
</style>